<template>
  <div>
    <div class="top-box">
      <span>{{$t('mohe')}}</span>
      <span class="mohe-desc">{{$t('overseasMohe')}}</span>
    </div>

    <div class="content-container">
      <div class="data-box">
        <p>{{$t('dataDes')}}</p>
        <div class="data-container">
          <div class="data-item">
            <span class="data-value">2,000,000+</span>
            <div class="data-line"></div>
            <span class="data-text">{{$t('dataNumber1')}}</span>
          </div>
          <div class="data-item">
            <span class="data-value">4,000,000+</span>
            <div class="data-line"></div>
            <span class="data-text">{{$t('dataNumber2')}}</span>
          </div>
          <div class="data-item">
            <span class="data-value">25,000,000+</span>
            <div class="data-line"></div>
            <span class="data-text">{{$t('dataNumber3')}}</span>
          </div>
        </div>
      </div>

      <div class="advantage-box">
        <p>{{$t('sixAdvantage')}}</p>

        <!-- <div class="advantage-container">
          <div v-for="(item, index) in advantagesArray"
              :key="index"
              class="advantage-item">
            <img :src="item.src"/>
            <span>{{item.desc}}</span>
          </div>
        </div> -->
        <el-row>
          <el-col
                :xs="12"
                :sm="8"
                :md="8"
                :lg="8"
                :xl="8" 
                v-for="(item, index) in advantagesArray"
                :key="index"
                class="advantage-container">
            <div class="advantage-item">
              <img :src="item.src"/>
              <span :class="isEn ? 'en-desc' : ''">{{$t(item.desc)}}</span>
            </div>
          </el-col>
        </el-row>

      </div>
    </div>

    <div class="apply-box">
      <span class="apply-use">{{$t('applyUse')}}</span>
      <span class="apply-desc">{{$t('beginService')}}</span>
      <el-button class="apply-btn" @click="jumpBusiness">{{$t('experienceNow')}}</el-button>
    </div>

    <fix-footer />
  </div>
</template>

<script>
import Footer from '@/components/Footer';

export default {

  data(){
    return {
      isEn: false,
      advantagesArray: [
        {
          src: require('../assets/mohe_blacklist.png'),
          desc: 'advantageBlacklist'
        },
        {
          src: require('../assets/mohe_review.png'),
          desc: 'advantageReview'
        },
                {
          src: require('../assets/mohe_result.png'),
          desc: 'advantageResult'
        },
        {
          src: require('../assets/mohe_chidu.png'),
          desc: 'advantageChidu'
        },
        {
          src: require('../assets/mohe_overdue.png'),
          desc: 'advantageOverdue'
        },
        {
          src: require('../assets/mohe_lead.png'),
          desc: 'advantageLead'
        },
      ]
    }
  },

  created(){
    const locale = localStorage.getItem('locale');
    if(locale === 'zh'){
      this.isEn = false;
    }else{
      this.isEn = true;
    }
  },

  watch: {
    '$i18n.locale'(){
      const locale = localStorage.getItem('locale');
      if(locale === 'zh'){
        this.isEn = false;
      }else{
        this.isEn = true;
      }
    }
  },

  methods: {
    jumpBusiness(){
      this.$router.push('/business');
    }
  },
  
  components: {
    'fix-footer': Footer,
  }
}
</script>

<style lang="less" scoped>

.top-box{
  background: url('../assets/mohe_bg.png') no-repeat center center;
  background-size: 100% 100%;
  height: 466px; /*px*/
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 60px 0;
  box-sizing: border-box;

  span{
    color: #fff;
    font-size: 60px;/*px*/
  }
  .mohe-desc{
    font-size: 35px; /*px*/
  }
}

p{
  font-size:32px; 
  font-family:PingFangSC-Semibold,PingFang SC;
  color:rgba(0,0,0,1);
  line-height:1.5;
  margin: 30px auto;
}

.content-container{
  background-color: rgb(240, 240, 240);
  padding: 30px 0;
}

.data-box{
  margin-bottom: 80px;

  .data-container{
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    padding: 0 400px;
    box-sizing: border-box;

    .data-item{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;

      .data-value{
        font-size: 35px; 
        color: #3B86FE;
        font-family:PingFangSC-Semibold,PingFang SC;
        line-height:49px;
      }

      .data-line{
        width: 120px;
        height: 3px; 
        background-color: #3B86FE;
        margin: 18px auto;
      }

      .data-text{
        font-size: 25px; 
        color: #000;
        line-height:40px;;
      }
    }
  }
}

.advantage-box{
  padding: 0 150px;

  .advantage-container{
    display: flex;
    flex-direction: row;
    justify-content: center;
    // flex-wrap: wrap;
    padding: 20px 0;
    // justify-content: space-around;

    .advantage-item{
      display: flex;
      flex-direction: column;
      width: 285px;
      height: 380px; 
      background:rgba(255,255,255,1);
      box-shadow:6px 4px 15px 0px rgba(0,0,0,0.05);
      border-radius:15px;
      margin-bottom: 40px;
      align-items: center;
      justify-content: space-between;

      span{
        color: #000;
        font-size: 20px; 
        line-height: 1.5;
        margin: auto 22px;
      }
      img{
        object-fit: contain;
        margin-top: 60px;
        width: 90px;
        height: 90px;
      }

      .en-desc{
        font-size: 20px;
        display: inline-block;
        text-align: left;
        text-justify:inter-cluster;
        line-height: 1.5;
        word-break: keep-all;
        word-wrap: break-word; // 只对英文起作用，以单词作为换行依据。
        white-space: pre-wrap; //只对中文起作用，强制换行。

        // text-align: left;
        // font-size: 22px;
      }
    }
  }

}

.apply-box{

  height: 400px; 
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  padding: 40px 0;
  box-sizing: border-box;

  .apply-use{
    font-size:35px; 
    font-family:PingFangSC-Medium,PingFang SC;
    color: #061E34;
  }

  .apply-desc{
    font-size:25px; 
    font-family:PingFangSC-Light,PingFang SC;
    color: #000;
  }

  .apply-btn{
    width: 300px;
    height: 70px; 
    border-radius: 35px;
    color: #fff;
    background-color: #3B86FE;
  }
}

@media only screen and (max-width: 768px) {

  p{
    font-size:20px; /*no*/
    line-height: 25px; /*no*/
  }

  .data-box{
    margin-bottom: 40px; /*no*/

    .data-container{
      padding: 0 60px; /*no*/

      .data-item{

        .data-value{
          font-size: 18px; /*no*/
          line-height:22px; /*no*/
        }

        .data-line{
          width: 80px; /*no*/
          height: 3px; /*no*/
          margin: 18px auto;/*no*/
        }

        .data-text{
          font-size: 14px; /*no*/
          line-height:20px;;/*no*/
        }
      }
    }
  }


  .advantage-box{
    
    .advantage-container{
      .advantage-item{

        width: 200px;/*no*/
        height: 250px; /*no*/
        span{
          font-size: 15px; /*no*/
          line-height: 22px;/*no*/
        }
        img{
          margin-top: 60px;/*no*/
          width: 60px;/*no*/
          height: 60px;/*no*/
        }
      }
    }
  }

  .apply-box{
    height: 200px; /*no*/
    padding: 40px 0;

    .apply-use{
      font-size:20px; /*no*/
    }

    .apply-desc{
      font-size:15px; /*no*/
    }

    .apply-btn{
      width: 150px;/*no*/
      height: 36px; /*no*/
      border-radius: 18px;/*no*/
    }
  }

}


</style>


// WEBPACK FOOTER //
// src/pages/Mohe.vue